<template>
    <div>
        <div>
            <img src="../assets/과학기술정보통신부_혼합_좌우.jpg"
                 alt="과학기술정보통신부 Ministry of Science and ICT"
                 style="width:350px;"/>
        </div>
        <div class="background">
            <template v-for="m in menus">
                <CircleMenu :menu="m" :key="m.idx"></CircleMenu>
            </template>
        </div>
        <p class="address">(28116) 충북 청주시 청원구 오창읍 연구단지로30 한국생명공학연구원 국가연구안전관리본부</p>
    </div>
</template>

<script>
    import CircleMenu from './CircleMenu.vue'

    export default {
        name: "Intro",
        components: {CircleMenu},
        data() {
            return {menus: []}
        },
        mounted() {
            this.menus = [
                {
                    idx: 0,
                    url: 'https://www.labs.go.kr/',
                    target: '_blank',
                    title: ['국가연구', '안전정보시스템'],
                    link: ['바로가기']
                },
                {
                    idx: 1,
                    url: '/mps',
                    title: ['시험・연구용', 'LMO 정보시스템'],
                    link: ['바로가기']
                },
                {
                    idx: 2,
                    url: '/intro/sub_new.html',
                    title: ['국가연구', '안전관리본부', '소개'],
                }
            ]
        }
    }
</script>

<style scoped>
    .background {
        background-color: #f2f2f2;
        padding: 30px 0;
    }

    .address {
        padding:0 10px;
    }


</style>